
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("cKu7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;
// donations/spakt.module.js
var $9481257a286d9d6c$var$init = module.exports.init = function init() {
    var attempts = 0;
    // if document.ready needed
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            var spakt_script = document.createElement("script");
            spakt_script.setAttribute("src", "/spenden/jetzt-helfen/file/?component=Customization&ft=js&file=js%2F002%2Fdonation-setup");
            document.head.appendChild(spakt_script);
        } else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=spakt.module.c2460584.js.map
